import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M7.75342 13.0854H10.6444",
  stroke: "currentColor",
  "stroke-width": "1.56168",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.41692 14.531C3.41692 14.9301 3.74051 15.2537 4.13967 15.2537H14.2581C14.6572 15.2537 14.9808 14.9301 14.9808 14.531V11.64C14.9808 11.2409 15.3044 10.9173 15.7036 10.9173C16.1027 10.9173 16.4263 11.2409 16.4263 11.64V14.531C16.4263 15.7285 15.4556 16.6992 14.2581 16.6992H4.13967C2.94219 16.6992 1.97144 15.7285 1.97144 14.531V4.41258C1.97144 3.21509 2.94219 2.24434 4.13967 2.24434H6.3079C6.70706 2.24434 7.03064 2.56793 7.03064 2.96709C7.03064 3.36625 6.70706 3.68983 6.3079 3.68983H4.13967C3.74051 3.68983 3.41692 4.01342 3.41692 4.41258V14.531Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M9.92163 4.41256L14.2581 8.74902",
  stroke: "currentColor",
  "stroke-width": "1.56168",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  d: "M9.92163 8.74906L14.2581 4.4126",
  stroke: "currentColor",
  "stroke-width": "1.56168",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5
  ]))
}